/*=========================================================================================
  File Name: moduleCommandeVerreState.js
  Description: module commandeVerreState
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  verresCommandes: []
}
